// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"0ca7c414","81":"4bb00199","94":"8007e35e","313":"f1a82724","404":"81c86a40","513":"78a41ec4","677":"c3a41abf","999":"f4871d06"}[chunkId] + ".chunk.js";
};